export const getSelectedUserDescription = (count: number, template: string) =>
  template.replace('{{count}}', String(count));
